import {RequestStatusCode} from './requestStatusCode';

export class RequestException implements Error {
  status: RequestStatusCode;
  statusText: string;

  constructor(status: number, statusText: string) {
    this.status = status;
    this.statusText = statusText;
  }

  message: string;
  name: string;
}
